import React, { Component } from 'react'
import { Route } from "react-router-dom";
import AboutMe from "./AboutMe"
import Details from "./Details"
import Skills from "./Skills"
import ProjectList from "./ProjectList"
import Contact from "./Contact"

export default class Main extends Component {
  render() {
    return (
      <div>
        <Route path="/" exact>
          <AboutMe />
        </Route>

        <Route exact path="/about">
          <Details />
        </Route>
        
        <Route exact path="/skills">
          <Skills />
        </Route>

        <Route exact path="/projects">
          <ProjectList /> 
        </Route>

        <Route exact path="/contact">
          <Contact /> 
        </Route>

      </div>
    )
  }
}
